module.exports = __webpack_public_path__ + "static/media/vpj-logo.d2984dfb.png";